export default "__VITE_ASSET__CqJmtf6L__"